export const stampeLino = {

	"title": "Light Print",
	"subtitle": "COLLECTION",
	"descriptionITA": "Una linea leggera, colorata piena di arricci su morbidi voile di cotone e lini preziosi. Trasparenze e strati leggeri da indossare durante le calde estati per un look super glam.",
    "descriptionENG": "A light, colorful line full of ruffles on soft cotton voile and organic Linens. Transparencies and light layers to wear during hot summers for a super glam look."


};

export const ricami = {

    "title": "Positano Couture",
    "subtitle": "COLLECTION",
    "descriptionITA": "La nostra linea Couture è piena di ricami preziosi su 100% lino. Abbiamo riprodotto la tradizione della nostra costiera lungo i nostri pezzi unici, impreziosendoli con ricami limone e greche antiche. Una collezione unica per non passare inosservate senza rinunciare all'eleganza senza tempo.",
    "descriptionENG": "Our Couture line is full of precious embroidery on 100% linen. We have reproduced the tradition of our coast along our unique pieces, embellishing them with lemon embroidery and ancient Greek. A unique collection not to go unnoticed without sacrificing timeless elegance."


};

export const stampeLinoProducts = [
    {
        "photo": "lookbook4/1_stampeLino/raw/01-Abito-LAGRAIN-SML--STAMPE-LINO--UNITI-LINO2.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/01-Abito-LAGRAIN-SML--STAMPE-LINO--UNITI-LINO2.jpg",
        "retromin": "",

        "prod1": "LAGRAIN",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/02-TOP-EMILY-U-COLORI-UNITI-COLORI-GARZA-STAMPE-LINO------GONNA-VERMENTINO-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/02-TOP-EMILY-U-COLORI-UNITI-COLORI-GARZA-STAMPE-LINO------GONNA-VERMENTINO-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retromin": "",

        "prod1": "TOP EMILY",
        "stile1": "Colori Uniti | Colori Garza | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA VERMENTINO",
        "stile2": "Ric. Grecia | Ric. Limone",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/03-CASACCA-ELBA-U--STAMPE-LINO-UNITI-LINO04.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/03-CASACCA-ELBA-U--STAMPE-LINO-UNITI-LINO04.jpg",
        "retromin": "",
        "prod1": "CASACCA ELBA",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/04-ABITO-DIAMANTE-SML-STAMPE-LINO2.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/04-ABITO-DIAMANTE-SML-STAMPE-LINO2.jpg",
        "retromin": "",
        "prod1": "ABITO DIAMANTE",
        "stile1": "Stampe Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/05-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO-2.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/05-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO-2.jpg",
        "retromin": "",
        "prod1": "ABITO AGADI",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/06-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO4.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/06-TUTA-BAIA-U-STAMPE-LINO-UNITI-LINO4.jpg",
        "retromin": "",
        "prod1": "TUTA BAIA",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/07-TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE------GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE6.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/07-TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE------GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE6.jpg",
        "retromin": "",
        "prod1": "TOP BIANCA",
        "stile1": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA NEVE",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/08-TOP-CALA-U--STAMPE-VOILE-----GONNA-VODKA-U-STAMPE-LINO2.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/08-TOP-CALA-U--STAMPE-VOILE-----GONNA-VODKA-U-STAMPE-LINO2.jpg",
        "retromin": "",
        "prod1": "TOP CALA",
        "stile1": "Stampe Voile",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA VODKA",
        "stile2": "Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/09-ABITO-ALIMINI-SML--UNITI-LINO--STAMPE-LINO7.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/09-ABITO-ALIMINI-SML--UNITI-LINO--STAMPE-LINO7.jpg",
        "retromin": "",
        "prod1": "ABITO ALIMINI",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/10-ABITO-ELECTRA-SML-UNITI-LINO-STAMPE-LINO10-ABITO-ELECTRA-SML-UNITI-LINO-STAMPE-LINO1.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/10-ABITO-ELECTRA-SML-UNITI-LINO-STAMPE-LINO10-ABITO-ELECTRA-SML-UNITI-LINO-STAMPE-LINO1.jpg",
        "retromin": "",
        "prod1": "ABITO ELECTRA",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA SMLXL",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/11-ABITO-TROPEA-SML-STAMPE-LINO2.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/11-ABITO-TROPEA-SML-STAMPE-LINO2.jpg",
        "retromin": "",
        "prod1": "ABITO TROPEA",
        "stile1": "Stampe Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/12-ABITO-ANTIBE-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/12-ABITO-ANTIBE-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retromin": "",
        "prod1": "ABITO ANTIBE",
        "stile1": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/13-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE3.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/13-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE3.jpg",
        "retromin": "",
        "prod1": "SPOLVERINO BELEN",
        "stile1": "Colori Garza | Stampe Voile",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    //TODO: pagine 12 mancante! @@@@
    {
        "photo": "lookbook4/1_stampeLino/raw/14TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE----GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/14TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE----GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retromin": "",
        "prod1": "TOP BIANCA",
        "stile1": "Stampe Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA NEVE",
        "stile2": "Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/15---GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/15---GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.jpg",
        "retromin": "",
        "prod1": "TOP EMILY",
        "stile1": "Colori Uniti | Colori Garza | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MEGAN",
        "stile2": "Colori Uniti | Stampe Lino",
        "taglia2": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/16TOP-CALA-U--STAMPE-VOILE-----GONNA-VODKA-U-STAMPE-LINO1.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/16TOP-CALA-U--STAMPE-VOILE-----GONNA-VODKA-U-STAMPE-LINO1.jpg",
        "retromin": "",
        "prod1": "TOP CALA",
        "stile1": "Stampe Voile",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA VODKA",
        "stile2": "Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/17-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO5.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/17-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO5.jpg",
        "retromin": "",
        "prod1": "ABITO AGADI",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/18CASACCA-ELBA-U--STAMPE-LINO-UNITI-LINO6.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/18CASACCA-ELBA-U--STAMPE-LINO-UNITI-LINO6.jpg",
        "retromin": "",
        "prod1": "CASACCA ELBA",
        "stile1": "Stampe Lino | Uniti Lino",
        "taglia1": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/1_stampeLino/raw/19-ABITO-TROPEA-SML-STAMPE-LINO2.jpg",
        "retro": "",
        "photomin": "lookbook4/1_stampeLino/min/19-ABITO-TROPEA-SML-STAMPE-LINO2.jpg",
        "retromin": "",
        "prod1": "ABITO TROPEA",
        "stile1": "Stampe Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    }
];

export const ricamiProducts = [
    //TODO: immagine diversa da quella del lookbook
    {
        "photo": "lookbook4/2_ricami/raw/60-ABITO-ARIA-SML-RIC.GRECIA-RIC.LIMONE1.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/60-ABITO-ARIA-SML-RIC.GRECIA-RIC.LIMONE1.jpg",
        "retromin": "",
        "prod1": "ABITO KAFTANO ARIA",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/61TOP-ACQUA-U-RIC.GRECIA-RIC.LIMONEGONNA-VERMENTINO-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE1.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/61TOP-ACQUA-U-RIC.GRECIA-RIC.LIMONEGONNA-VERMENTINO-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE1.jpg",
        "retromin": "",
        "prod1": "TOP ACQUA",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA VERMENTINO",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/62ABITO-SUGAR-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/62ABITO-SUGAR-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retromin": "",
        "prod1": "ABITO SUGAR",
        "stile1": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia1": "TAGLIA XSSM",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/63TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE-----GONNA-NEVE-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE7.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/63TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE-----GONNA-NEVE-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE7.jpg",
        "retromin": "",
        "prod1": "TOP BIANCA",
        "stile1": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA NEVE",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/64SPOLVERINO-COUVE-LUNGO-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO7.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/64SPOLVERINO-COUVE-LUNGO-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO7.jpg",
        "retromin": "",
        "prod1": "SPOLVERINO COUVE LUNGO",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT LINDO",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA XSSM",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/68ABITO-ARIA-SML-RIC.GRECIA-RIC.LIMONE2copia.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/68ABITO-ARIA-SML-RIC.GRECIA-RIC.LIMONE2copia.jpg",
        "retromin": "",
        "prod1": "ABITO ARIA",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA SML",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/69ABITO-SUGAR-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/69ABITO-SUGAR-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retromin": "",
        "prod1": "ABITO SUGAR",
        "stile1": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia1": "TAGLIA XSSM",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/70SPOLVERINO-COUVE-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/70SPOLVERINO-COUVE-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retromin": "",
        "prod1": "SPOLVERINO COUVE LUNGO",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT LINDO",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA XSSM",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/71TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE-----GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE6.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/71TOP-BIANCA-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE-----GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE6.jpg",
        "retromin": "",
        "prod1": "TOP BIANCA",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA BIANCA",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/65SPOLVERINO-COUVE-LUNGO-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/65SPOLVERINO-COUVE-LUNGO-U-RIC.GRECIA-RIC.LIMONESHORT-LINDO-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.jpg",
        "retromin": "",
        "prod1": "SPOLVERINO COUVE",
        "stile1": "Ric. Grecia | Ric. Limone",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT LINDO",
        "stile2": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia2": "TAGLIA XSSM",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/66TOP-FIANO-U-COLORI-LINO-STAMPE-LINOGONNA-GIN-U-RIC.GRECIA-RIC.LIMONE5.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/66TOP-FIANO-U-COLORI-LINO-STAMPE-LINOGONNA-GIN-U-RIC.GRECIA-RIC.LIMONE5.jpg",
        "retromin": "",
        "prod1": "TOP FIANO",
        "stile1": "Colori Lino | Stampe Lino",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA GIN",
        "stile2": "Ric. Grecia | Ric. Limone",
        "taglia2": "TAGLIA UNICA",

        "colori": ""
    },
    {
        "photo": "lookbook4/2_ricami/raw/67ABITO-ANTIBE-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE2.jpg",
        "retro": "",
        "photomin": "lookbook4/2_ricami/min/67ABITO-ANTIBE-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE2.jpg",
        "retromin": "",
        "prod1": "ABITO ANTIBE",
        "stile1": "Ric. Grecia | Ric. Limone | Stampe Lino",
        "taglia1": "TAGLIA SML",

        "colori": ""
    }
];
